import { AfterViewInit, Component, forwardRef, Input, OnInit, input, output, viewChild } from "@angular/core";
import { NgForm, NgModel, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { SelectItem } from "primeng/api";
import { Community } from "../../../types/organization";
import { PCPCommunitySelectorBaseComponent } from '../pcp-community-selector.basecomponent';

import { ErrormessageComponent } from "../../validation/errormessage/errormessage.component";
import { SelectModule } from "primeng/select";
import { FluidModule } from "primeng/fluid";

@Component({
    selector: "pcp-community-dropdown",
    templateUrl: "./pcp-community-dropdown.component.html",
    styleUrls: [],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => PCPCommunityDropdownComponent),
        }
    ],
    standalone: true,
    imports: [SelectModule, FormsModule, FluidModule, ErrormessageComponent]
})
export class PCPCommunityDropdownComponent extends PCPCommunitySelectorBaseComponent {
  readonly communitySelection = viewChild<NgModel>("communitySelection");

  readonly communities = input<Community[]>([]);
  readonly placeholder = input<string>("Communities");

  _selectedCommunity: Community;

  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set selectedCommunity(community: Community) {
    this._selectedCommunity = community;
    this.propagateChange(this._selectedCommunity);
  };

  get selectedCommunity(): Community {
    return this._selectedCommunity;
  }

  readonly selectedCommunityChange = output<Community>();

  constructor() {
    super();
  }
   
  writeValue(obj: any): void {
    this.selectedCommunity = obj;
  }

  getCommunityOptions(): SelectItem[] {
    const communities = (!this.selectedCommunity) ? this.communities() : this.sortSelectedTop(this.communities(), [this.selectedCommunity]);
    return this.communitiesToOptions(communities);
  }

  onChange() {
    this.selectedCommunityChange.emit(this.selectedCommunity);
  }

  selectCommunityById(orgId: number) {
    const selectedCommunity = this.communities().find((community: Community) => community.orgId === orgId);
    if(!selectedCommunity) { throw new TypeError(`PCPCommunityDropdownComponent.selectCommunityById(${orgId}) : community not found.`);}

    this.clearSelectedCommunities();
    this.selectCommunity(selectedCommunity);
  }

  private selectCommunity(community: Community) {
    this.selectedCommunity = community;
  }

  private clearSelectedCommunities(): void {
    this.selectedCommunity = null;
  }
}
